import React from "react";
import { NavLink } from "react-router-dom";
import typo from "@/styles/Typography.module.css";
import { AdminLineItem } from "@/components";
import SafeLocalStorage from "@/utils/safeLocalStorage";
import { STORAGE_KEYS } from "@/constants/storage";

export default function AdminHub() {
  // Get the auth session from localStorage
  const authSession = SafeLocalStorage.get(STORAGE_KEYS.AUTH_SESSION);
  const fullName = authSession?.name || authSession?.email || "Admin";
  const userName = fullName.split(' ')[0]; // Get just the first name
  return (
    <div style={{ width: "100%" }}>
    <AdminLineItem title="Admin Dashboard" user={userName}>
      <div className="mb-4">
        <h1 className="mt-4" style={{color: "#F16D09"}}>Admin Dashboard</h1>
        <p style={{fontSize: "var(--font-subtitle)", color: "#492C28", paddingLeft: "3rem", paddingRight: "3rem"}}>Welcome to the admin area, {userName}. Select an area to manage from the left or manage your users below.</p>
      </div>

{/* User management tools */}
      <div className="row g-1">
      <div>
          <div style={{ paddingTop: "1.7rem"}}>
            <p style={{ textAlign: "left", paddingLeft: ".5rem", color: "#F16D09", fontSize: "var(--font-heading-sm )"}}>
        USER MANAGEMENT TOOLS
            </p>
          </div>
        </div>
        <div>
          <div className={typo.cardWhite_narrow} style={{ paddingTop: ".5rem"}}>
           <NavLink
            to="/admin/users/create"
            className={({ isActive }) => (isActive ? typo.navLinkActive : "")}
            style={{ display: "block", padding: ".5rem", textDecoration: "none", color: "inherit", textAlign: "left" }}
          >
            Create Users - set up a user record with details, and set permissions for that user. 
          </NavLink>
          </div>
        </div>
        <div>
          <div className={typo.cardWhite_narrow}>
           <NavLink
            to="/admin/users/manage"
            className={({ isActive }) => (isActive ? typo.navLinkActive : "")}
            style={{ display: "block", padding: ".5rem", textDecoration: "none", color: "inherit", textAlign: "left" }}
          >
            Manage Users - check and edit user records, set validation enforcement and enable multi-hospice settings.
          </NavLink> 
          </div>
        </div>

           <div>
          <div style={{ paddingTop: "1.7rem"}}>
            <p style={{ textAlign: "left", paddingLeft: ".5rem", color: "#F16D09", fontSize: "var(--font-heading-sm )"}}>
        ROLE MANAGEMENT TOOLS
            </p>
          </div>
        </div>

          <div className={typo.cardWhite_narrow} style={{ paddingTop: ".5rem"}}>
           <NavLink
            to="/admin/users/permissions"
            className={({ isActive }) => (isActive ? typo.navLinkActive : "")}
            style={{ display: "block", padding: ".5rem", textDecoration: "none", color: "inherit", textAlign: "left" }}
          >
              Manage Roles - create and edit roles to be used in setting up access controls
          </NavLink>
          </div>

          <div>
          <div style={{ paddingTop: "1.7rem"}}>
            <p style={{ textAlign: "left", paddingLeft: ".5rem", color: "#F16D09", fontSize: "var(--font-heading-sm )"}}>
        HOSPICE MANAGEMENT TOOLS
            </p>
          </div>
        </div>
            
          <div className={typo.cardWhite_narrow} style={{ paddingTop: ".5rem"}}>
           <NavLink
            to="/admin/users/hospiceLists"
            className={({ isActive }) => (isActive ? typo.navLinkActive : "")}
            style={{ display: "block", padding: ".5rem", textDecoration: "none", color: "inherit", textAlign: "left" }}
          >
            Manage Hospice Lists - set up and edit lists of hospices to be used as quick reference list when publishing surveys.
          </NavLink>
          </div>

          <div className={typo.cardWhite_narrow} style={{ paddingTop: ".5rem"}}>
           <NavLink
            to="/admin/users/hospiceUsers"
            className={({ isActive }) => (isActive ? typo.navLinkActive : "")}
            style={{ display: "block", padding: ".5rem", textDecoration: "none", color: "inherit", textAlign: "left" }}
          >
            Find Hospice Users - view a list of all users associated with a particular hospice.
          </NavLink>
          </div>
        {/* add other cards if needed */}
      </div>
    </AdminLineItem>
    </div>
  );
}
